import { createAuthClient } from "better-auth/react";
import { resetTelemetryUser } from "./telemetry";

const apiOrigin = import.meta.env.VITE_API_URL || window.location.origin;

export const authClient = createAuthClient({
  baseURL: `${apiOrigin}/api/auth`,
  fetchOptions: { credentials: "include" },
});

export function signInWithGoogle() {
  return authClient.signIn.social({
    provider: "google",
    callbackURL: `${window.location.origin}/dashboard`,
    errorCallbackURL: window.location.origin,
  });
}

export async function signOut() {
  await authClient.signOut();
  resetTelemetryUser();
  window.location.assign("/");
}
